// import React, { useEffect, useState } from "react";
// import "./Header.scss";
// import { FaArrowRightLong } from "react-icons/fa6";
// import { HiMenuAlt2 } from "react-icons/hi";
// import { MdOutlineCloseFullscreen } from "react-icons/md";

// import { TbMessageChatbotFilled } from "react-icons/tb";
// import { BsDot } from "react-icons/bs";
// import { GoDot } from "react-icons/go";
// import { assets } from "../Asset/Assets";
// import { IoIosArrowDown } from "react-icons/io";
// import { FiMenu } from "react-icons/fi";

// const Header = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(null);

//   const OpenMenu = (value) => {
//     if (!isMenuOpen) {
//       setIsMenuOpen(true);
//     }
//     setIsMenuOpen(!isMenuOpen);
//   };

//   return (
//     <div>
//       <header className="header">

//         <FiMenu onClick={OpenMenu} />

//         <div className="header_items_wrapper">
//           <ul>
//             <li>
//               تواصل معنا
//               <IoIosArrowDown />
//             </li>
//             <li>المنصات</li>
//             <li>الاستعلامات</li>
//             <li>الخدمات</li>
//             <li>مركز المعرفة</li>
//             <li>عن بلدي</li>
//           </ul>

//           <button>
//             {" "}
//             <span> Get us now </span> <FaArrowRightLong />{" "}
//           </button>

//           <div className="logo">
//             <div className="logo_wrapper">
//               <img src={assets.logo} alt="" />
//             </div>
//           </div>
//         </div>

//         {isMenuOpen && (

//           <div className="menu">

//             <ul>
//               <li>
//               عن بلدي

//               </li>
//               <li>مركز المعرفة
//               </li>
//               <li>لخدمات
//               </li>
//               <li>الاستعلامات
//               </li>
//               <li>المنصات
//               </li>
//               <li>تواصل معنا</li>
//             </ul>
//           </div>
//         )}

//       </header>
//     </div>
//   );
// };

// export default Header;

import React, { useEffect, useState } from "react";
import "./Header.scss";
import { FaArrowRightLong } from "react-icons/fa6";
import { HiMenuAlt2 } from "react-icons/hi";
import {
  MdArrowDropDown,
  MdKeyboardArrowLeft,
  MdOutlineCloseFullscreen,
} from "react-icons/md";

import { TbMessageChatbotFilled } from "react-icons/tb";
import { BsDot } from "react-icons/bs";
import { GoDot } from "react-icons/go";
import { assets } from "../Asset/Assets";
import { IoIosArrowDown, IoIosLink } from "react-icons/io";
import { FiMenu } from "react-icons/fi";

const Header = () => {


  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // const [ anBaldi, setAnBalade ] = useState(false);

  const [ open , setOpen ] = useState();

  const [ selectedItem , setSelectedItem ] = useState()


  const toggleOpen = (item) => {
    setSelectedItem(item);

    
      setSelectedItem(selectedItem === item ? null : item);
    

    if (item) {
      setOpen(true)
    }else {

      setOpen(false)
    };
  };


  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen); // Toggle menu open/close state
  };

  return (
    <div>
      <header className="header">
        <FiMenu onClick={toggleMenu} />

        <div className="header_items_wrapper">
          <ul>
            <li onClick={()=> toggleOpen("thavasilMazhnaa") }>
              تواصل معنا
              <IoIosArrowDown />
            </li>
            <li onClick={()=> toggleOpen("mansath") }>
              المنصات
              <IoIosArrowDown />
            </li>
            <li onClick={()=> toggleOpen("isthazhlamath") } >
              الاستعلامات
              <IoIosArrowDown />
            </li>
            <li onClick={()=> toggleOpen("khidmath") } >
              الخدمات
              <IoIosArrowDown />
            </li>
            <li onClick={()=> toggleOpen("markazhmazhrafath") } >
              مركز المعرفة <IoIosArrowDown />{" "}
            </li>
            <li onClick={()=> toggleOpen("anBalad") } >
              عن بلدي <IoIosArrowDown />{" "}
            </li>
          </ul>

          <div className="logo">
            <div className="logo_wrapper">
              <img src={assets.logo} alt="" />
            </div>
          </div>
        </div>

        <div className="drop_down_nav">

          <div className="baground_img">

          </div>

      {/* item 1  */}


{  selectedItem === "anBalad" && open === true ? 

 <div className="drop_down_nav_colums_wrapper">

          <div className="drop_down_nav_colums">
            <span>من نحن</span>
            <ul className="nav_ul">
              <li className="nav_li">
                الهيكل التنظيمي <MdKeyboardArrowLeft />
              </li>
              <li className="nav_li">
                الهيكل الإستراتيجي للوزارة <MdKeyboardArrowLeft />
              </li>
            </ul>
          </div>

          <div className="drop_down_nav_colums">
            <span>من نحن</span>
            <ul className="nav_ul">
              <li className="nav_li">
                الهيكل التنظيمي <MdKeyboardArrowLeft />
              </li>
              <li className="nav_li">
                الهيكل الإستراتيجي للوزارة <MdKeyboardArrowLeft />
              </li>
              <li className="nav_li">
                السياسات والاستراتيجيات <MdKeyboardArrowLeft />
              </li>
              <li className="nav_li">
                أهداف التنمية المستدامة
                <MdKeyboardArrowLeft />{" "}
              </li>
              <li className="nav_li">
                الأنظمة واللوائح <MdKeyboardArrowLeft />
              </li>
              <li className="nav_li">
                الشركاء <MdKeyboardArrowLeft />
              </li>
              <li className="nav_li">
                الوظائف <MdKeyboardArrowLeft />
              </li>
              <li className="nav_li">
                تواصل معنا <MdKeyboardArrowLeft />
              </li>
            </ul>
          </div>

          <div className="drop_down_nav_colums">
            <span>من نحن</span>
            <ul className="nav_ul">
              <li className="nav_li">
                الهيكل التنظيمي <MdKeyboardArrowLeft />{" "}
              </li>
              <li className="nav_li">
                الهيكل الإستراتيجي للوزارة <MdKeyboardArrowLeft />
              </li>
              <li className="nav_li">
                السياسات والاستراتيجيات <MdKeyboardArrowLeft />
              </li>
              <li className="nav_li">
                أهداف التنمية المستدامة <MdKeyboardArrowLeft />
              </li>
              <li className="nav_li">
                الأنظمة واللوائح <MdKeyboardArrowLeft />
              </li>
              <li className="nav_li">
                الشركاء <MdKeyboardArrowLeft />
              </li>
              <li className="nav_li">
                الوظائف <MdKeyboardArrowLeft />
              </li>
              <li className="nav_li">
                تواصل معنا <MdKeyboardArrowLeft />
              </li>
            </ul>
          </div>

          <div className="drop_down_nav_colums">
            <span>من نحن</span>
            <ul className="nav_ul">
              <li className="nav_li">
                الهيكل التنظيمي <MdKeyboardArrowLeft />
              </li>
              <li className="nav_li">
                الهيكل الإستراتيجي للوزارة <MdKeyboardArrowLeft />
              </li>
              <li className="nav_li">
                السياسات والاستراتيجيات <MdKeyboardArrowLeft />
              </li>
              <li className="nav_li">
                أهداف التنمية المستدامة <MdKeyboardArrowLeft />
              </li>
              <li className="nav_li">
                الأنظمة واللوائح <MdKeyboardArrowLeft />
              </li>
              <li className="nav_li">
                الشركاء <MdKeyboardArrowLeft />
              </li>
              <li className="nav_li">
                الوظائف <MdKeyboardArrowLeft />
              </li>
              <li className="nav_li">
                تواصل معنا <MdKeyboardArrowLeft />
              </li>
            </ul>
          </div>

          </div>

           : "" }




   {/* item 2   */}
          
            {  selectedItem === "markazhmazhrafath" && open === true ? 
            <div className="drop_down_nav_colums_wrapper">


<div className="drop_down_nav_colums">
  <span>بيانات وإحصائيات </span>
  <ul className="nav_ul">
    <li className="nav_li">
    البيانات المفتوحة <MdKeyboardArrowLeft />{" "}
    </li>
    <li className="nav_li">
    إحصائيات ومؤشرات المنصة <MdKeyboardArrowLeft />
    </li>
   
  </ul>
</div>

<div className="drop_down_nav_colums">
  <span>مبادرات وشراكات </span>
  <ul className="nav_ul">
    <li className="nav_li">
    المبادرات <MdKeyboardArrowLeft />
    </li>
    <li className="nav_li">
    المبادرات <MdKeyboardArrowLeft />
    </li>
    <li className="nav_li">
    منصة استطلاع <MdKeyboardArrowLeft />
    </li>
    <li className="nav_li">
    منصة تفاعل <MdKeyboardArrowLeft />
    </li>
   
  </ul>
</div>

</div> 
 : "" } 







{/* item 3 */}

{  selectedItem === "khidmath" && open === true ? 

 <div className="drop_down_nav_colums_wrapper_kidmath">

  <div className="drop_down_nav_colums_wrapper_sub">



<div className="drop_down_nav_colums">
  <span> الرخص التجارية </span>
  <ul className="nav_ul">
    <li className="nav_li">
    إصدار رخصة تجارية <MdKeyboardArrowLeft />
    </li>
    <li className="nav_li">
    تجديد رخصة نشاط تجاري <MdKeyboardArrowLeft />
    </li>
    <li className="nav_li">
    إلغاء رخصة نشاط تجاري <MdKeyboardArrowLeft />
    </li>
  </ul>
</div>

<div className="drop_down_nav_colums">
  <span>التفويض البلدي الإلكتروني</span>
  <ul className="nav_ul">
    <li className="nav_li">
    إضافة منشأة إلى مدير حساب <MdKeyboardArrowLeft />
    </li>
    <li className="nav_li">
    الاستعلام عن طلبات منشأة <MdKeyboardArrowLeft />
    </li>
    <li className="nav_li">
    الاستعلام عن مفوضي منشأة <MdKeyboardArrowLeft />
    </li>


  </ul>
</div>

<div className="drop_down_nav_colums">
  <span>  المنظمات والأنظمة </span>
  <ul className="nav_ul">
    <li className="nav_li">
    منصة رسم إشغال مرافق الإيواء <MdKeyboardArrowLeft />{" "}
    </li>
    <li className="nav_li">
    منصة رسم تقديم منتجات التبغ <MdKeyboardArrowLeft />
    </li>
    <li className="nav_li">
    <span className="anim_blue"> الجديد </span>  بلدي أعمال <MdKeyboardArrowLeft />
    </li>
    <li className="nav_li">
    تصنيف مقدمي خدمات المدن <MdKeyboardArrowLeft />
    </li>
   
  </ul>
</div>

<div className="drop_down_nav_colums">
  <span>  الصفحات الشخصية </span>
  <ul className="nav_ul">
    <li className="nav_li">
    إدارة الطلبات <MdKeyboardArrowLeft />
    </li>
    <li className="nav_li">
      
    إدارة الرخص <MdKeyboardArrowLeft />
    </li>
    <li className="nav_li">
   <span className="anim_"> الجديد </span>
    لوحة التحكم
       <MdKeyboardArrowLeft />
    </li>

   
  </ul>
</div>

</div>


<div className="drop_down_nav_colums_wrapper_sub">



<div className="drop_down_nav_colums">
  <span>خدمات التقارير المساحية</span>
  <ul className="nav_ul">
    <li className="nav_li">
    إصدار تقرير مساحي <MdKeyboardArrowLeft />
    </li>

  </ul>
</div>

<div className="drop_down_nav_colums">
  <span>خدمات تنسيق المشروعات</span>
  <ul className="nav_ul">
    <li className="nav_li">
    خدمات تنسيق أعمال البنية التحتية <MdKeyboardArrowLeft />
    </li>
    <li className="nav_li">
    خدمات تنسيق المشروعات الكبرى <MdKeyboardArrowLeft />
    </li>



  </ul>
</div>

<div className="drop_down_nav_colums">
  <span> الشهادات الصحية </span>
  <ul className="nav_ul">
    <li className="nav_li">
    إصدار شهادة صحية <MdKeyboardArrowLeft />{" "}
    </li>
    <li className="nav_li">
    تجديد شهادة صحية<MdKeyboardArrowLeft />
    </li>

  </ul>
</div>

<div className="drop_down_nav_colums">
  <span> الرخص الإنشائية </span>
  <ul className="nav_ul">
    <li className="nav_li">
    إصدار رخصة بناء <MdKeyboardArrowLeft />
    </li>
    <li className="nav_li">
    خدمة إصدار رخصة تسوير أراضي فضاء
 <MdKeyboardArrowLeft />
    </li>


   
  </ul>
</div>

</div> 



</div>

 : "" } 



       {/* item 4  */}


{  selectedItem === "isthazhlamath" && open === true ? 

<div className="drop_down_nav_colums_wrapper">

         <div className="drop_down_nav_colums">
           <span>خدمات إكرام الموتى</span>
           <ul className="nav_ul">
             <li className="nav_li">
             الاستعلام عن مقدمي خدمات نقل وتجهيز الموتى (الجهات الخيرية)
             <MdKeyboardArrowLeft />
             </li>

             <li className="nav_li">
             الاستعلام عن قبر متوفي
             <MdKeyboardArrowLeft />
             </li>

             <li className="nav_li">
             طباعة شهادة دفن
             <MdKeyboardArrowLeft />
             </li>

    
             <li className="nav_li">
الاستعلام عن المقابر

                <MdKeyboardArrowLeft />
             </li>
           </ul>
         </div>

         <div className="drop_down_nav_colums">
           <span>الاستعلامات التجارية</span>
           <ul className="nav_ul">
             <li className="nav_li">
             استعلام عن رخصة نشاط تجاري <MdKeyboardArrowLeft />
             </li>
             <li className="nav_li">
             الأنشطة التجارية والاشتراطات البلدية  <MdKeyboardArrowLeft />
             </li>
             <li className="nav_li">
             الاستعلام عن مسارات العربات المتجولة
             <MdKeyboardArrowLeft />
             </li>
     
      
     
           </ul>
         </div>

         <div className="drop_down_nav_colums">
           <span>الأراضي والبناء </span>
           <ul className="nav_ul">
             <li className="nav_li">
             استعلام عن رخصة بناء <MdKeyboardArrowLeft />{" "}
             </li>
             <li className="nav_li">
             المستكشف الجغرافي <MdKeyboardArrowLeft />
             </li>
             <li className="nav_li">
             مستكشف التغطية لخدمات البنية التحتية <MdKeyboardArrowLeft />
             </li>
             <li className="nav_li">
             الاستعلام عن تقرير مساحي <MdKeyboardArrowLeft />
             </li>
      
    
  
           </ul>
         </div>

         <div className="drop_down_nav_colums">
           <span>  الاستعلامات العامة </span>
           <ul className="nav_ul">
             <li className="nav_li">
             الاستعلام عن المخالفة للإجراءات الاحترازية <MdKeyboardArrowLeft />
             </li>
             <li className="nav_li">
             حاسبة الرسوم المعلوماتية <MdKeyboardArrowLeft />
             </li>
             <li className="nav_li">
             الاستعلام عن المكاتب الهندسية <MdKeyboardArrowLeft />
             </li>
             <li className="nav_li">
             الاستعلام عن عقود النظافة <MdKeyboardArrowLeft />
             </li>
             <li className="nav_li">
             أسواق المتاجر المتنقلة  <MdKeyboardArrowLeft />
             </li>
             <li className="nav_li">
             الاستعلام عن الإيقافات <MdKeyboardArrowLeft />
             </li>
             <li className="nav_li">
             الاستعلام عن المخالفات <MdKeyboardArrowLeft />
             </li>
             {/* <li className="nav_li">
               تواصل معنا <MdKeyboardArrowLeft />
             </li> */}
           </ul>
         </div>

         </div>

          : "" }





{/* item 5 */}

{ selectedItem === "mansath" && open === true ? 


<div className="drop_down_nav_colums_wrapper">

<div className="drop_down_nav_colums_wrapper_links">

<div className="drop_down_nav_colums_wrapper_links_clumn">
<div className="drop_down_nav_colums_wrapper_links_item">
        <h5> منصة تحدي الاستثمار الاجتماعي للقطاع البلدي والإسكان
        </h5> <IoIosLink />

      </div>
</div>


  <div className="drop_down_nav_colums_wrapper_links_clumn">
  <div className="drop_down_nav_colums_wrapper_links_item">
        <h5> المنصات التفاعلية  </h5> <IoIosLink />

      </div>
</div>

<div className="drop_down_nav_colums_wrapper_links_clumn">
      <div className="drop_down_nav_colums_wrapper_links_item">
        <h5>بوابة الفرص الاستثمارية</h5> <IoIosLink />

      </div>
  </div>
</div>




</div> 

: "" } 




{/* item 6 */}

{  selectedItem === "thavasilMazhnaa" && open === true ? 


<div className="drop_down_nav_colums_wrapper">

<div className="drop_down_nav_colums_wrapper_links">


  


<div className="drop_down_nav_colums_wrapper_links_clumn">
      <div className="drop_down_nav_colums_wrapper_links_item">
        <h5> الأسئلة الشائعة </h5> <IoIosLink />

      </div>

      <div className="drop_down_nav_colums_wrapper_links_item">
        <h5> وسائل التواصل الإجتماعي </h5> <IoIosLink />

      </div>

  </div>






  <div className="drop_down_nav_colums_wrapper_links_clumn">
  <div className="drop_down_nav_colums_wrapper_links_item">
        <h5> بلاغ عن فساد  </h5> <IoIosLink />

      </div>
      <div className="drop_down_nav_colums_wrapper_links_item">
        <h5> دليل الأمانات </h5> <IoIosLink />

      </div>

</div>



<div className="drop_down_nav_colums_wrapper_links_clumn">
<div className="drop_down_nav_colums_wrapper_links_item">
        <h5> اتصل بنا
        </h5> <IoIosLink />

      </div>

      <div className="drop_down_nav_colums_wrapper_links_item">
        <h5> الدعم الفني بلغة الإشارة
        </h5> <IoIosLink />

      </div>

      <div className="drop_down_nav_colums_wrapper_links_item">
        <h5> حجز موعد إلكتروني
                 </h5> <IoIosLink />

      </div>
</div>





</div>




</div>

: "" }


        </div>

        {/* Mobile menu with active class based on state */}
        <div className={`menu ${isMenuOpen ? "active" : ""}`}>
          <ul className="menuUl">
            <li className="mobLi">
              {" "}
              <MdArrowDropDown />
              عن بلدي
            </li>
            <li className="mobLi">
              <MdArrowDropDown />
              مركز المعرفة
            </li>
            <li className="mobLi">
              <MdArrowDropDown />
              الخدمات
            </li>
            <li className="mobLi">
              <MdArrowDropDown />
              الاستعلامات
            </li>
            <li className="mobLi">
              <MdArrowDropDown />
              المنصات
            </li>
            <li className="mobLi">
              <MdArrowDropDown />
              تواصل معنا
            </li>
          </ul>
        </div>
      </header>
    </div>
  );
};

export default Header;
